// Handle resend confirmation form submission
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('resend-form');

  if (!form) return; // Not on resend confirmation page

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    const email = document.getElementById('email').value;
    const submitBtn = document.getElementById('submit-btn');
    const errorDiv = document.getElementById('error-messages');
    const successDiv = document.getElementById('success-message');

    // Hide previous messages
    errorDiv.classList.add('d-none');
    successDiv.classList.add('d-none');

    // Disable button
    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando...';

    fetch('/users/resend_confirmation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ email: email })
    })
    .then(response => response.json())
    .then(data => {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Reenviar e-mail de confirmação';

      if (data.message) {
        successDiv.textContent = data.message;
        successDiv.classList.remove('d-none');
        document.getElementById('email').value = '';
      } else if (data.errors) {
        const errors = Object.values(data.errors).flat();
        errorDiv.textContent = errors.join(', ');
        errorDiv.classList.remove('d-none');
      }
    })
    .catch(error => {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Reenviar e-mail de confirmação';
      errorDiv.textContent = 'Erro ao enviar e-mail. Tente novamente.';
      errorDiv.classList.remove('d-none');
    });
  });
});
